// Same rules as /^[^\s@]+@[^\s@]+\.[^\s@]+$/, checked in linear time (no regex backtracking):
// no whitespace, exactly one '@' with text before it, and a '.' in the domain that is
// neither its first nor its last character.
export function isValidEmail(email: string): boolean {
  // RegExp.test() converted its argument to a string, so keep that for non-string input
  const value = String(email);

  const atIndex = value.indexOf('@');
  if (atIndex <= 0 || value.includes('@', atIndex + 1)) return false;

  for (const ch of value) {
    if (ch.trim() === '') return false;
  }

  const domain = value.slice(atIndex + 1);
  const dotIndex = domain.indexOf('.', 1);
  return dotIndex !== -1 && dotIndex < domain.length - 1;
}
